import request from '@/utils/http'
export function getNewsBanner () {
  return request({
    method: 'POST',
    url: '/rest/house/newsCenter/listBanner'
  })
}
export function getMultiMedia () {
  return request({
    method: 'POST',
    url: '/rest/house/newsCenter/queryMultiMedia'
  })
}
// 查询集团新闻
export function getGroupNews (data) {
  return request({
    method: 'POST',
    url: '/rest/house/newsCenter/queryGroupNews',
    data
  })
}
// 根据id查询详细新闻
export function getGroupNewsDetail (data) {
  return request({
    method: 'POST',
    url: '/rest/house/newsCenter/queryNewsDetail',
    data
  })
}

// 新闻访问量
export function getPV (data) {
  return request({
    method: 'POST',
    url: '/rest/house/newsCenter/visitNews',
    data
  })
}
// 推荐新闻
export function recommendNews (data) {
  return request({
    method: 'POST',
    url: '/rest/house/newsCenter/queryRecommendNews',
    data
  })
}

export function getMediaPerspective () {
  return request({
    method: 'POST',
    url: '/rest/house/newsCenter/queryMediaPerspective'
  })
}



// WEBPACK FOOTER //
// ./src/api/newscenter/index.js